// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__Zyvxf","container":"styles_container__170Kc","title":"styles_title__1BHEg","wrapper":"styles_wrapper__2XHac","answer":"styles_answer__3esuv"};